import type { Company } from '../types/auth';
import { useCallStore } from '../store/useCallStore';

// Übernimmt die Filter-Vorgaben des Unternehmens in die aktuelle Ansicht.
// Genutzt beim Login, beim Wiederherstellen nach einem Reload und wenn ein Admin
// die Unternehmens-Konfiguration ändert (company_update über den WebSocket).
export function applyCompanyDefaults(company: Company | null): void {
  if (!company) return;
  const cfg = company.filterConfig;
  useCallStore.getState().setFilter({
    period: cfg.defaultPeriod,
    count: cfg.defaultCount,
    missedOnly: cfg.missedOnly,
    ...(cfg.defaultFields.length > 0 ? { fields: cfg.defaultFields } : {}),
  });
}
